import { RETRIEVE_DOMAIN_DETAILS } from "../action";
import { domainDetails } from "./initial-store";

const initialState = domainDetails;

function domainReducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    case RETRIEVE_DOMAIN_DETAILS:
      newState = { ...action.payload };
      return newState;
    default:
      return state;
  }
}

export default domainReducer;
